import { httpApi } from './http.api';

export const handleHttpRequest = async <T, R>(
  method: 'get' | 'post' | 'patch' | 'delete',
  url: string,
  payload?: R,
): Promise<T> => {
  try {
    const { data } = await httpApi[method]<T>(url, payload);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};
